module.exports = __webpack_public_path__ + "img/ico_firmware_updating.89df9fa3.svg";